import { debounce, makeStyles, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useQaId } from "lqx-react/lib/forms/qa-ids";
import React, { useEffect, useState } from "react";

export const DigiSelectAsync = ({ id = 'id', label = 'name', getItems, $value, isMulti, placeholder, disableClearable = true, styles, ...rest }: { id?: string, label?: string, getItems: any, $value: any, isMulti?: boolean, placeholder?: string, disableClearable?: boolean, styles?: any }) => {
    const classes = useDigigSelectAsyncStyles();

    const [options, setOptions] = useState([]);
    const [open, setOpen] = useState(false);
    const loading = open && options.length === 0;
    const dataQaId = useQaId(rest['data-qa-id'] || 'digi-select-async');

    const getLoadOptions = async (query, callback) => {
        const response = await getItems(query);
        callback(response.items ? response.items : response);
    };
    const loadOptions = debounce(getLoadOptions, 300);

    useEffect(() => {
        let active = true;

        if (!loading) {
            return undefined;
        }

        (async () => {
            if (active) {
                await getLoadOptions('', setOptions);
            }
        })();

        return () => {
            active = false;
        };
    }, [loading]);

    useEffect(() => {
        if (!open) {
            setOptions([]);
        }
    }, [open]);

    const setValue = (newValue) => {
        $value.set(newValue);
    }

    const ariaLabel: string = rest['aria-label'];

    return (
        <Autocomplete
            aria-label={ ariaLabel }
            multiple={isMulti}
            disableClearable={disableClearable}
            data-qa-id={dataQaId}
            size="small"
            options={options}
            loading={loading}
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            value={$value.value}
            filterOptions={(x) => x}
            getOptionLabel={(option) => option[label]}
            getOptionSelected={(option, value) => option[id] === value[id]}
            filterSelectedOptions
            className={classes.inputBase}
            onChange={(_, selectedValue: any) => {
                setOptions(selectedValue ? [selectedValue, ...options] : options);
                setValue(selectedValue);
            }}
            onInputChange={(_, newInputValue) => {
                loadOptions(newInputValue, setOptions);
            }}
            style={styles}
            renderInput={(params) => (
                <TextField
                    label={ ariaLabel }
                    {...params}
                    variant="outlined"
                    color="secondary"
                    placeholder={placeholder}
                    className={[$value.length ? '' : 'error', classes.outlinedInput].join(' ')}
                />
            )}
        />
    )
}

const useDigigSelectAsyncStyles = makeStyles({
    inputBase: {
        '& .MuiInputBase-root': {
            border: '1px solid #E3E9ED',
            borderRadius: 2
        },
        '& .MuiInputBase-root:hover': {
            borderColor: 'hsl(0,0%,70%)'
        }
    },
    outlinedInput: {
        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
        '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-endAdornment': {
            right: 0
        }
    }
});
